import { Breadcrumbs } from "components/breadcrumbs";
import { AdminAccountRoleForm } from "./components";
import { IAdminAccountRoleForm } from "interfaces";
import { useCreate } from "@refinedev/core";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FullScreenLoading } from "components/fullScreenLoading";

export const CreateAdminAccountRole : React.FC = () => {
  const navigate = useNavigate();
  const { mutate, isLoading: isLoading } = useCreate();

  const onSubmit = (values: IAdminAccountRoleForm) => {
    const submitValues = {...values};
    mutate({
      resource: "admin-account/role",
      invalidates: [],
      meta: {
        ignoreResourceWrapper: true
      },
      values: {
        ...submitValues
      },
    },
    {
      onSuccess: () => {
        toast.success("Create successfully");
        navigate(`/admin-accounts/roles`);
      },
    });
  }
  
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create new Role" />
      <AdminAccountRoleForm onSubmit={onSubmit} />
      {isLoading ? <FullScreenLoading /> : <></>}
    </div>
  );
}